import cx from 'classnames'
import { useContext } from 'react'
import { MdExpandMore } from 'react-icons/md'

import styles from './card.module.css'
import { CardContext } from './context'

interface Props {
  onChangeOpen?: (value: boolean) => void
  open?: boolean
}

export function ExpandableButton ({ onChangeOpen, open }: Props): JSX.Element {
  const cardContext = useContext(CardContext)

  const currentValue = typeof open === 'boolean'
    ? open
    : typeof cardContext?.open === 'boolean'
      ? cardContext.open
      : true

  function onClick (): void {
    const newValue = typeof open === 'boolean'
      ? !open
      : typeof cardContext?.open === 'boolean'
        ? !cardContext.open
        : true

    onChangeOpen?.(newValue)
    cardContext?.setOpen(newValue)
  }

  return (
    <button
      onClick={onClick}
      data-test-id='expand-collapse'
      title={currentValue ? 'Collapse' : 'Expand'}
      className={cx(styles.expandableButton, {
        [styles.open as string]: currentValue
      })}
    >
      <MdExpandMore className={styles.arrowIcon} />
    </button>
  )
}
